import React, { createContext, useContext } from 'react';
import { ChevronDown } from 'lucide-react';

const AccordionContext = createContext({});

// Native details keeps answers in the initial HTML and works without JavaScript.
// Collapsed answers are user-operable disclosure content, not hidden SEO text.
export const Accordion = ({ children, className, onValueChange, 'data-testid': testId }) => (
  <AccordionContext.Provider value={{ onValueChange }}>
    <div className={className} data-testid={testId}>{children}</div>
  </AccordionContext.Provider>
);

export const AccordionItem = ({ children, className, value, 'data-testid': testId }) => {
  const { onValueChange } = useContext(AccordionContext);
  return (
    <details className={`readable-faq ${className || ''}`} data-testid={testId}
      onToggle={(event) => { if (event.currentTarget.open) onValueChange?.(value); }}>
      {children}
    </details>
  );
};

export const AccordionTrigger = ({ children, className, ...props }) => (
  <summary className={`flex items-center justify-between gap-3 cursor-pointer ${className || ''}`} {...props}>
    {children}<ChevronDown className="h-4 w-4 shrink-0 transition-transform" aria-hidden="true" />
  </summary>
);

export const AccordionContent = ({ children, className, ...props }) => (
  <div className={className} {...props}>{children}</div>
);